// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck

import { Scene } from './scene';
import { Video } from '../video/video';
import {
  SceneAssetItem,
  SceneItemType,
  SceneVoiceoverItem,
} from './scene-item';

export const getSceneItems = ({
  scene,
  video,
}: {
  scene: Scene;
  video?: Video;
}) => {
  if (scene.items && scene.items.length > 0) {
    return scene.items;
  }

  if (!scene.audioUrl || !scene.assetId) {
    return [];
  }

  const backwardCompatibilityVoiceover: SceneVoiceoverItem = {
    url: scene.audioUrl,
    format: scene.audioFormat,
    duration: scene.audioDuration,
    voiceoverId: video?.voiceoverId as string,
    checksum: scene.checksum,
    words: scene.words,
  };

  const backwardCompatibilityAsset: SceneAssetItem = {
    assetId: scene.assetId,
    originalAssetId: scene.originalAssetId,
    assetPrompt: scene.assetPrompt,
    transition: scene.transition,
    motion: scene.motion,
  };

  return [
    {
      index: 0,
      start: 0,
      end: scene.audioDuration,
      type: SceneItemType.Voiceover,
      data: backwardCompatibilityVoiceover,
    },
    {
      index: 1,
      start: 0,
      end: scene.audioDuration,
      type: SceneItemType.Asset,
      data: backwardCompatibilityAsset,
    },
    ...(scene.items || []),
  ];
};
